import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

import A from '../A';
import View from '../../learning/checkWrongAnswer/view/View';
import Indexing from '../../learning/checkWrongAnswer/Indexing';
import { useRequest } from '../../../hooks';
import { checkWransrAnswerAPI } from '../../../api/learningAPI';

function CheckWrongAnswer() {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(0);
  const [checkWransrAnswerAPICall, data] = useRequest((data) => checkWransrAnswerAPI(data));


  useEffect(() => {
    if (location.search) {
      const { search } = location;
      const parsed = queryString.parse(search);
      if (!parsed?.lrnMbrId) return;
      
      const { lrnMbrId, lrnTmeSn, lrnEntyScnCd, stgCd, langCd, token } = parsed;
      checkWransrAnswerAPICall({
        langCd, lrnTmeSn, lrnMbrId, lrnEntyScnCd, stgCd, token
      });
    }
  }, [location]);
  
  const handleClose = () => {
    window.parent.postMessage("onClose", "*");
  }
  if (!data) return <div />;

  return (
    <div className="layout-def layout-lc theme-gray">
      <div className="header">
				<div className="inner">
					<div className="headerBox">
						<div className="headerBox_head">
							<h1 className="tit">오답확인</h1>
              <A
                className="btn-close-wrap"
                onClick={handleClose}
              >닫기</A>
						</div>
					</div>
				</div>
			</div>
      <div className="container ovy-h">
        <div className="inner">
          <div className="wa-wrapper">
            <Indexing data={ data } currentIndex={ currentPage } onClick={ setCurrentPage } />
            <View data={ data[ currentPage ] } />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckWrongAnswer;